import request from "/utils/request";
import globals from "/utils/globals";

export default () => {
  let requestParams = {};

  if (globals.couponCode) {
    requestParams.coupon_code = globals.couponCode; // eslint-disable-line camelcase
  }

  return request
    .get("/api/plans", {
      params: requestParams
    })
    .then(config => {
      if (config) {
        return config;
      } else {
        throw new Error("No plans found.");
      }
    });
};
